/**
 * @file Initilizing options for cytoscape.js-edgehandles extension, which is used for edge creation.
 */

export const ehDefaults = {
  hoverDelay: 0,
  snap: true, // 启用 snap 功能，基于鼠标位置检测目标节点
  snapThreshold: 0, // 鼠标必须到达节点边界才触发连接（1px 容差）
  snapFrequency: 15, // 每秒检测 15 次
};
